import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  UncontrolledAlert
} from "reactstrap";
import { login, clearMsg } from "../../actions/auth";
import { Helmet } from "react-helmet";
import Cookies from "js-cookie";
import { getProfile } from "../../actions/user";
class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: ""
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  componentDidMount() {
    this.props.clearMsg();
    if (Cookies.get("access_token")) {
      this.props.getProfile("auth");
    }
  }

  render() {
    let { email, password } = this.state;
    let { loading, errorMsg, errors } = this.props.auth;
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>登陸 - 美南新聞</title>
          {/* <link rel="canonical" href="https://soonbus.com/login" /> */}
        </Helmet>
        <Col lg="5" md="7">
          {errorMsg && (
            <UncontrolledAlert color="danger" fade={false}>
              <span className="alert-inner--text">{errorMsg}</span>
            </UncontrolledAlert>
          )}
          <Card className=" shadow border-0">
            <CardHeader className="bg-transparent">
              <h1 className="d-flex justify-content-center align-items-center">
                登陸
              </h1>
            </CardHeader>
            <CardBody className="px-lg-5 py-lg-2">
              <Form onSubmit={this.onSubmit}>
                <FormGroup className="mb-3">
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-email-83" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="email"
                      name="email"
                      id="loginEmail"
                      onChange={this.onInputChange}
                      value={email}
                      invalid={!!errors.email_or_phone}
                      placeholder="郵箱"
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="password"
                      name="password"
                      id="loginPassword"
                      onChange={this.onInputChange}
                      value={password}
                      invalid={!!errors.password}
                      placeholder="密碼"
                    />
                  </InputGroup>
                </FormGroup>
                <div className="custom-control custom-control-alternative custom-checkbox">
                  <input
                    className="custom-control-input"
                    id=" customCheckLogin"
                    type="checkbox"
                  />
                  <label
                    className="custom-control-label"
                    htmlFor=" customCheckLogin"
                  >
                    <span className="text-muted">記住我</span>
                  </label>
                </div>
                <div className="text-center">
                  <Button
                    className="my-4 col-12"
                    color="danger"
                    type="submit"
                    disabled={loading}
                  >
                    登陸
                  </Button>
                </div>
              </Form>
              <Row className="my-3">
                <Col xs="6">
                  <Link
                    className="text-dark"
                    href="#forgot-password"
                    onClick={e => e.preventDefault()}
                    // to="forgot-password"
                  >
                    <small>忘記密碼</small>
                  </Link>
                </Col>
                <Col className="text-right" xs="6">
                  <Link className="text-dark" to="register">
                    <small>新用戶註冊</small>
                  </Link>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </>
    );
  }

  onInputChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  onSubmit(e) {
    e.preventDefault();
    let { email, password } = this.state;
    this.props.login(email, password);
    this.setState({
      password: ""
    });
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
    user: state.user
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: (email, password) => dispatch(login(email, password)),
    getProfile: params => dispatch(getProfile(params)),
    clearMsg: () => dispatch(clearMsg())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
